import React from "react";
import { Switch, Route, useRouteMatch } from "react-router-dom";
import OnixCodetableItemsList from "./OnixCodetableItemsList";
import { RoleEnum } from "../../types/RoleEnum";
import { RouteGuard } from "../../guards/RouteGuard";
import OnixCodetableItemsCreate from "./OnixCodetableItemsCreate";
import OnixCodetableItemsEdit from "./OnixCodetableItemsEdit";
function OnixCodetableItems() {
    var path = useRouteMatch().path;
    var cleanPath = path.replace("/*", "");
    return (React.createElement(Switch, null,
        React.createElement(Route, { exact: true, path: cleanPath, render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR] },
                React.createElement(OnixCodetableItemsList, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/create"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR] },
                React.createElement(OnixCodetableItemsCreate, null))); } }),
        React.createElement(Route, { path: "".concat(cleanPath, "/edit/:id"), render: function () { return (React.createElement(RouteGuard, { allowedRoles: [RoleEnum.ONIX_CODETABLES_ADMINISTRATOR] },
                React.createElement(OnixCodetableItemsEdit, null))); } })));
}
export default OnixCodetableItems;
